import JoinGroupButton from './JoinGroupButton';
import JoinGroupButtonContainer from './JoinGroupButton.container';
export default JoinGroupButtonContainer(JoinGroupButton);

//# sourceMappingURL=index.js.map